import { FC, ReactNode } from 'react';
import { Box, Stack } from '@mui/material';

interface Props {
  sidebar?: ReactNode;
}

export const PageContentLayout: FC<Props> = ({ sidebar, children }) => {
  return (
    <Stack direction="row" gap={2}>
      {sidebar ? (
        <Box sx={{ position: 'relative' }}>
          <Box sx={{ position: 'sticky', top: 15 }}>{sidebar}</Box>
        </Box>
      ) : null}

      <Box sx={{ width: '100%', minWidth: 0 }}>{children}</Box>
    </Stack>
  );
};
